
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Point } from '../../shared/contracts/AnswerContract';

@Component
export default class PointIndicator extends Vue {
    @Prop() point: Point;
}
